import moment from "moment";

/**
 *
 */
export class DateMask {

    /**
     * @param {HTMLElement} input
     * @param {object} settings
     */
    constructor(input, settings) {
        settings = settings || {};
        var htmlInput;
        // Init values
        this.settings = {
            htmlInputClass: 'datemask-html',
            minDate: new Date('1900-01-01'),
            maxDate: new Date(),
            ...settings,
        };
        this.input = input;
        this.htmlInput = htmlInput = this._createHtmlInput(this.settings);
        // Current key code
        this.keyCode = null;
        this.keyDownCode = null;
        // Every date part is composed of multiple chars
        this.dayChars = [null, null];
        this.monthChars = [null, null];
        this.yearChars = [null, null, null, null];
        this.ageRestrictionPopupShowed = false; // Has been popup showed yet?
        // Hide input
        this.input.classList.add('is-hidden');
        // Add HTMLInput in DOM
        this.input.parentElement.insertBefore(this.htmlInput, this.input);

        // Init values with functions
        this.setValue('DD.MM.RRRR');
        this._renderInput(false);

        // --------------------------- Handlers ------------------------------- \\

        // Check if jquery add invalid class in input field
        this._addClassNameListener(input, function () {
            if (input.classList.contains('invalid')) {
                htmlInput.parentElement.classList.add('has-error');
            } else {
                htmlInput.parentElement.classList.remove('has-error');
            }
        });

        this.htmlInput.addEventListener('keydown', this.handleKeydown.bind(this));
        this.htmlInput.addEventListener('input', this.handleInput.bind(this));
        this.htmlInput.addEventListener('click', this.handleFocus.bind(this));
        // Float label
        this.htmlInput.addEventListener('blur', this.handleBlur.bind(this))
        this.htmlInput.addEventListener('focus', this.handleFocus.bind(this))
        // Prevent from selecting
        this.htmlInput.addEventListener('selectstart', function (e) {
            e.preventDefault();
        })
        // Prevent from copy paste
        this.htmlInput.addEventListener('cut', function (e) {
            e.preventDefault();
        });
        this.htmlInput.addEventListener('copy', function (e) {
            e.preventDefault();
        });
        this.htmlInput.addEventListener('paste', function (e) {
            e.preventDefault();
        })

        // Unit tests
        this._unitTestValidateDate();
    }

    // -------------------------------- Getters & Setters ----------------------------------------- \\

    /**
     * @returns {string}
     */
    getValue() {
        let value = '';

        // Day
        if (this.dayChars[0] != null) {
            value += String(this.dayChars[0]);
        }

        if (this.dayChars[1] != null) {
            value += String(this.dayChars[1]);
            value += '.'
        }

        // Month
        if (this.monthChars[0] != null) {
            value += String(this.monthChars[0]);
        }

        if (this.monthChars[1] != null) {
            value += String(this.monthChars[1]);
            value += '.'
        }

        // Year
        if (this.yearChars[0] != null) {
            value += String(this.yearChars[0]);
        }

        if (this.yearChars[1] != null) {
            value += String(this.yearChars[1]);
        }

        if (this.yearChars[2] != null) {
            value += String(this.yearChars[2]);
        }

        if (this.yearChars[3] != null) {
            value += String(this.yearChars[3]);
        }

        return value;
    }

    /**
     * @param {string} value
     */
    setValue(value) {
        //
        let parts = this._extractDatePartsFromValue(value);

        // Set data chars
        this.dayChars = parts.day;
        this.monthChars = parts.month;
        this.yearChars = parts.year;
        //
        this._updateInputValue();
    }

    /**
     * @private
     */
    _updateInputValue() {
        var $ = jQuery;

        this.input.value = this.getValue();
        //
        $(this.input).trigger('change');
    }

    /**
     * Delete char in passed position
     *
     * @param position
     * @private
     */
    _deleteCharInPosition(position) {
        let index;

        // Caret is just after dot
        if (position === 3 || position === 6) {
            position -= 1;
        }

        index = position - 1;

        // Day
        if (position <= 2) {
            this.dayChars[index] = null;
            this._updateInputValue();

            return
        }

        // Month
        if (position <= 5) {
            index = index - (2 + 1);
            this.monthChars[index] = null;
            this._updateInputValue();

            return;
        }

        // Year
        if (position <= 10) {
            index = index - (2 + 1) - (2 + 1);
            this.yearChars[index] = null;
            this._updateInputValue();

            return;
        }
    }

    // -------------------------------- Handlers ----------------------------------------- \\

    handleKeydown(e) {
        const keyCode = e.keyCode;

        // Prevent left and right arrow
        if([37, 39].includes(keyCode)) {
            e.preventDefault();
        }

        this.keyDownCode = keyCode;
    }

    /**
     * Handle/Process input event
     *
     * @param e
     */
    handleInput(e) {
        e.preventDefault();
        let keyCode = null;

        // --------------- Key code -------------- \\
        if(this.keyDownCode === 8) { // Delete
            keyCode = 8;
        } else { // Otheh input chars
            keyCode = e.data.charCodeAt(0);
        }

        // Check if char is allowerd
        if (!this._isCharAllowed(keyCode)) {
            this._renderInput(true);
            return;
        }

        this.keyCode = keyCode;

        // ------------ Delete char ----------- \\

        if (this.keyCode === 8) {
            this._deleteCharInPosition(this._caretPosition());

            // Render input
            this._renderInput(true)
            return;
        }

        // Add zero before num if user input dot, decimal point
        if((this.keyCode === 190 || this.keyCode === 46) && this._canAddZero()) {
            // Edit day
            if(this._caretPosition() === 1) {
                this.dayChars[1] = this.dayChars[0];
                this.dayChars[0] = 0;
            }

            // Edit month
            if(this._caretPosition() === 4) {
                this.monthChars[1] = this.monthChars[0];
                this.monthChars[0] = 0;
            }

            // Render input
            this._renderInput(true)
            return;
        }

        // ------------ Add new char ---------- \\

        // Check if value is valid date
        if (this._isValidDate(this.htmlInput.textContent)) {
            this.setValue(this.htmlInput.textContent);
        }

        // Render input
        this._renderInput(true)


        // ----------------------- Maybe add zero (again) ------------------ \\

        // Add zero if user input day num between 4 and 9
        if(this._caretPosition() === 1 && [4, 5, 6, 7, 8, 9].includes(this._getDayNum(this.htmlInput.textContent))) {
            // Edit day
            this.dayChars[1] = this.dayChars[0];
            this.dayChars[0] = 0;

            this._renderInput(true)
        }

        // Add zero if user input month num between 2 and 9
        if (this._caretPosition() === 4 && (this._getMonthNum(this.htmlInput.textContent) >= 2 && this._getMonthNum(this.htmlInput.textContent) <= 9)) {
            // Edit month
            this.monthChars[1] = this.monthChars[0];
            this.monthChars[0] = 0;

            this._renderInput(true)
        }


    }

    handleBlur(e) {
        var $ = jQuery;
        const $field = $(this.htmlInput);
        const $container = $field.closest('.moved-input-container');
        const isFulldateValid = DateMask.isFulldateValid(this.input.value);

        if (this.input.value.length === 0) {
            $container.removeClass('is-floating');
        }


        // Check
        if (!isFulldateValid) {
            this._showError('Formát data není správný', true);
            return;
        }

        // Check if passed date meet age restriction
        if(!DateMask.isValidByAgeRestriction(this.input.value)) {
            if (!this.ageRestrictionPopupShowed) {
                // Show popup
                $.fancybox.open({
                    src: '#age-restriction-popup'
                });

                this.ageRestrictionPopupShowed = true;
            }

            // Show error
            this._showError('Musí ti být nejméně 13 let', true);

            return;
        }

        // Valid
        this._hideError();

    }

    /**
     * @param e
     */
    handleFocus(e) {
        this._hideError();
        //
        this._updateCaretPosition();
    }

    // -------------------------------- Validators ----------------------------------------- \\

    /**
     * Check if user input allowed char
     * @param keyCode
     * @return bool
     * @private
     */
    _isCharAllowed(keyCode) {

        // Numbers
        if ((keyCode >= 48 && keyCode <= 57)|| (keyCode >= 96 && keyCode <= 105)) {
            return true;
        }

        // Decimal point
        if (keyCode === 190 || keyCode === 46) {
            return true;
        }

        // Delete
        if (keyCode === 8) {
            return true;
        }

        return false;
    }

    /**
     * Validate value as full date
     *
     * @param {string} value
     * @return {bool}
     */
    static isFulldateValid(value) {
        if (value.length !== 10) {
            return false
        }

        var day = value[0] + value[1];
        var month = value[3] + value[4];
        var year = value[6] + value[7] + value[8] + value[9];

        var datetime = new Date(year + '-' + month + '-' + day);
        datetime.setFullYear(year);
        datetime.setMonth(month - 1);
        datetime.setDate(day);

        // Date is not valid
        if (isNaN(datetime.getTime())) {
            return false;
        }

        // Date is higher than current date
        if (datetime.getTime() > (new Date()).getTime()) {
            return false;
        }

        // Check if passed datetime has same day, month and year as created datetime (to prevent passing wrong dates)
        if ((datetime.getDate() !== parseInt(day)) || (datetime.getMonth() + 1 !== parseInt(month)) || (datetime.getFullYear() !== parseInt(year))) {
            return false;
        }

        // Year is lower than 1900
        if (year < 1900) {
            return false;
        }

        return true;
    }

    /**
     * Check if input is valid for age restriction
     *
     * @param {string} value
     * @private
     */
    static isValidByAgeRestriction(value) {
        const age = DateMask._getAge(value);

        if(age >= 13) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Check if passed value is valid date
     *
     * @param {string} value
     * @return bool
     * @private
     */
    _isValidDate(value) {
        let parts = this._extractDatePartsFromValue(value);

        // Validate day
        if(!this._isValidDateDay(value)) {
            return false;
        }

        // Validate month
        if(!this._isValidDateMonth(value)) {
            return false;
        }

        // Validate year
        if(!this._isValidDateYear(value)) {
            return false;
        }

        return true;
    }

    /**
     * Check if day of date is valid
     * @param {string} value
     * @returns {boolean}
     * @private
     */
    _isValidDateDay(value) {
        let parts = this._extractDatePartsFromValue(value);
        const day = parts.day;

        // First digit cannot be higher than 3 if second is filled
        if(day[0] > 3 && day[1] !== null) {
            return false;
        }

        // First digit cannot be lower than 0
        if(day[0] < 0) {
            return false;
        }

        // Both digits cannot be 0
        if(day[0] === 0 && day[1] === 0) {
            return false;
        }

        // Second digit cannot be higher than 1 if first digit is 3
        if(day[0] === 3 && day[1] > 1) {
            return false;
        }

        return true;
    }

    /**
     * @param {string} value
     * @returns {boolean}
     * @priv1ate
     */
    _isValidDateMonth(value) {
        let parts = this._extractDatePartsFromValue(value);
        const month = parts.month;
        //
        const dayNum = this._getDayNum(value);
        const monthNum = this._getMonthNum(value);

        // First digit cannot be higher than 1 if second is filled
        if(month[0] > 1 && month[1] !== null) {
            return false;
        }

        // First digit cannot be lower than 0
        if(month[0] < 0) {
            return false;
        }

        // Both digits cannot be 0
        if(month[0] === 0 && month[1] === 0) {
            return false;
        }

        // Second digit cannot be higher than 2 if first digit is 1
        if(month[0] === 1 && month[1] > 2) {
            return false;
        }

        // Check if filled day is valid by month
        if(dayNum > this._daysInMonth(monthNum)) {
            return false
        }

        return true;

    }

    /**
     * @param {string} value
     * @returns {boolean}
     * @priv1ate
     */
    _isValidDateYear(value) {
        let parts = this._extractDatePartsFromValue(value);
        const day = parts.day;
        const month = parts.month;
        const year = parts.year;
        //
        const dayNum = this._getDayNum(value);
        const monthNum = this._getMonthNum(value);
        const yearNum = this._getYearNum(value);
        const filledYearNum = this._getFilledDatePartNum(year);
        // min year
        const minYearNum = this.settings.minDate.getFullYear();
        const minYearParts = String(minYearNum).split('');
        // max year
        const maxYearNum = this.settings.maxDate.getFullYear();
        const maxYearParts = String(maxYearNum).split('');

        //First digit cannot be 0
        if(year[0] === 0) {
            return false;
        }

        // Year is empty
        if((year[0] + year[1] + year[2] + year[3]) === 0) {
            return true;
        }


        // First digit cannot be lower than minYearParts
        if(year[0] < minYearParts[0]) {
            return false;
        }

        // First digit cannot be higher than minYearParts
        if(year[0] > maxYearParts[0]) {
            return false;
        }

        // First digit cannot be lower than 0
        if(year[0] < 0) {
            return false;
        }

        // Filled year cannot be higher than max
        if (this._getFilledDatePartNum(year, 0) > maxYearNum) {
            return false;
        }

        if (this._getFilledDatePartNum(year, 9) < minYearNum) {
            return false;
        }

        if ((!parts.month.includes(null) && !year.includes(null))
            &&
            dayNum > this._daysInMonth(monthNum, yearNum)
        ) {
            return false;
        }

        return true;
    }

    // -------------------------------- Renders ----------------------------------------- \\

    _renderInput(updateCaretPosition) {
        updateCaretPosition = updateCaretPosition || false;

        // clear HTML content
        this.htmlInput.innerHTML = '';

        // Days
        this.dayChars.forEach((value) => {
            this.htmlInput.appendChild(this._createInputChar(value, 'D'))
        })
        // Point
        this.htmlInput.appendChild(this._createInputChar('.', '.', this.dayChars.includes(null) ? false : true));
        // Months
        this.monthChars.forEach((value) => {
            this.htmlInput.appendChild(this._createInputChar(value, 'M'))
        })
        // Point
        this.htmlInput.appendChild(this._createInputChar('.', '.', this.monthChars.includes(null) ? false : true));
        // Years
        this.yearChars.forEach((value) => {
            this.htmlInput.appendChild(this._createInputChar(value, 'R'))
        })

        if(updateCaretPosition) {
            this._updateCaretPosition();
        }
    }


    // -------------------------------- Factories ----------------------------------------- \\

    /**
     * @param {string} value
     * @param {string|null} defaultValue
     * @return HTMLElement
     * @private
     */
    _createInputChar(value, defaultValue, notPlaceholder) {
        let element = document.createElement('span');
        notPlaceholder = notPlaceholder || false;

        // Is number?
        if (parseInt(value) === value) {
            // Char
            element.innerText = value;
            element.classList.add('datemask-char')
        } else {
            // Placeholder
            element.innerText = defaultValue;

            if(notPlaceholder) {
                element.classList.add('datemask-char')
            } else {
                element.classList.add('datemask-placeholder-char')
            }
        }

        return element;
    }

    /**
     * @param {object} settings
     * @returns {HTMLElement}
     * @private
     */
    _createHtmlInput(settings) {
        let htmlInput = document.createElement('div');
        //
        htmlInput.setAttribute('contenteditable', true);
        htmlInput.setAttribute('inputmode', 'numeric');
        htmlInput.classList.add(...this.settings.htmlInputClass.split(' '));

        return htmlInput;
    }

    // -------------------------------- Caret position ----------------------------------------- \\

    /**
     * Find current caret position
     * @returns {number}
     * @private
     */
    _caretPosition() {
        // Date is filled
        if(!this.yearChars.includes(null)) {
            return 10;
        }

        // Year
        for (var i = 4; i > 0; i--) {
            if (this.yearChars[i - 1] !== null) {
                // days + point + months + point + year
                return (2 + 1) + (2 + 1) + i;
            }
        }

        // Month
        for (var i = 2; i > 0; i--) {
            if (this.monthChars[i - 1] !== null) {
                // month is filled
                if (i == 2) {
                    return (2 + 1) + (2 + 1);
                }

                // days + point + month
                return (2 + 1) + i;
            }
        }

        // Days
        for (var i = 2; i > 0; i--) {
            if (this.dayChars[i - 1] !== null) {
                // day is filled
                if (i == 2) {
                    return 2 + 1;
                }

                return i;
            }
        }

        // Default
        return 0;
    }

    /**
     * Update carret position
     * @private
     */
    _updateCaretPosition() {
        let range = document.createRange();
        let selection = window.getSelection();

        if(this._caretPosition() == 10) {
            // Date is filled
            range.setStart(this.htmlInput.childNodes[9], 1);
        } else {
            range.setStart(this.htmlInput.childNodes[this._caretPosition()], 0);
        }

        selection.removeAllRanges();
        selection.addRange(range);
    }

    // -------------------------------- Date helpers ----------------------------------------- \\


    /**
     * Find how many days are in passed month or in passed year's month. Function supports leap years
     *
     * @param {number} m Month
     * @param {number} y Year
     * @returns {number|number}
     * @private
     */
    _daysInMonth(m, y) {
        if(m == 2 && y == undefined) {
            return 29; // february can hsave max 29 days (in leap year)
        }

        switch (m) {
            case 2:
                return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28; // is leap year?
            case 4:
            case 6:
            case 9:
            case 11:
                return 30;
            default:
                return 31
        }
    }

    /**
     * Extract date parts from value
     *
     * @private
     * @return object
     */
    _extractDatePartsFromValue(value) {
        let parts = value.split('.');
        //

        return {
            'day': this._filterDatePart(parts[0], 2),
            'month': this._filterDatePart(parts[1], 2),
            'year': this._filterDatePart(parts[2], 4)
        }
    }

    /**
     * @param {string} value
     * @returns {number}
     * @private
     */
    _getDayNum(value) {
        let parts = this._extractDatePartsFromValue(value);
        let day = parts.day;

        return parseInt(String(day[0]) + String(day[1]));
    }

    /**
     * @param {string} value
     * @returns {number}
     * @private
     */
    _getMonthNum(value) {
        let parts = this._extractDatePartsFromValue(value);
        let month = parts.month;

        return parseInt(String(month[0]) + String(month[1]));
    }

    /**
     * @param {string} value
     * @returns {number}
     * @private
     */
    _getYearNum(value) {
        let parts = this._extractDatePartsFromValue(value);
        let year = parts.year;

        return parseInt(String(year[0]) + String(year[1]) + String(year[2]) + String(year[3]));
    }

    /**
     * @param {array} datePart
     * @return string
     * @private
     */
    _getFilledDatePartNum(datePart, fillnumber) {
        var filledPart = this._getFilledDatePart(datePart, fillnumber);
        let num;

        for(let key in filledPart) {
            let digit = filledPart[key];

            if(num) {
                num += String(digit);
            } else {
                num = String(digit);
            }
        }

        return num;
    }

    /**
     * Fill date part with 0 if some date part is null/is missing
     *
     * @param {array} datePart
     * @private
     */
    _getFilledDatePart(datePart, fillnumber) {
        var fillnumber = fillnumber || 0;
        let filledDatePart = [];

        for (let key in datePart) {
            let digit = datePart[key];

            if(digit === null) {
                digit = fillnumber;
            }

            filledDatePart.push(digit);
        }

        return filledDatePart;
    }

    /**
     * Check if date is filled
     *
     * @return bool
     * @private
     */
    _isDateFilled() {
        if(this.dayChars.includes(null)) {
            return false;
        }

        if(this.monthChars.includes(null)) {
            return false;
        }

        if(this.yearChars.includes(null)) {
            return false;
        }

        return false;
    }

    /**
     * @param {string} value
     * @returns {number}
     * @private
     */
    static _getAge(value)
    {
        const today = moment();
        const birthDate = moment(value, 'DD.MM.YYYY');

        return today.diff(birthDate, 'years');
    }

    // function getAge(value)
    // {
    //     let today = new Date();
    //     let birthDate = new Date(value);
    //     let age = today.getFullYear() - birthDate.getFullYear();
    //     let m = today.getMonth() - birthDate.getMonth();
    //
    //     if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    //         age--;
    //     }
    //
    //     console.log(age);
    //
    //     return age;
    // }
    //
    // getAge('10.10.2015');

    /**
     * Check if passed datepart is filled
     *
     * @param {array} datePart
     * @return {bool}
     * @private
     */
    _isDatePartFilled(datePart) {
        let valid = true;

        for(let digit in datePart) {
            if(digit == null) {
                valid = false;
                break;
            }
        }

        return valid;
    }

    /**
     * @param {string} value
     * @param {number} numDigits
     * @returns {number[]}
     * @private
     */
    _filterDatePart(value, numDigits) {
        let digits = value.toString().split('');
        digits = digits.map(Number)

        if (digits.length < numDigits) {
            for (var i = digits.length; i < numDigits; i++) {
                digits[i] = null;
            }
        } else if (numDigits < digits.length) {
            for (var i = digits.length; i >= numDigits; i--) {
                digits.splice(i, 1);
            }
        }

        // Replace NaN with null
        digits.forEach((value, index) => {
            if (isNaN(value)) {
                digits[index] = null;
            }
        })

        return digits;
    }

    /**
     * Check if we can add zero in input (to create double digit number)
     *
     * @returns {boolean}
     * @private
     */
    _canAddZero() {
        if (this._caretPosition() == 1 || this._caretPosition() == 4) {
            return true;
        }

        return false
    }

    /**
     * Hide date error
     *
     * @private
     */
    _hideError() {
        let error = this.htmlInput.parentElement.querySelector('#date_of_birth-error');

        if(error) {
            this.htmlInput.parentElement.classList.remove('has-error');
            //
            error.remove();
        }
    }

    /**
     * Show date error
     *
     * @param {string|undefined} msg
     * @param {boolean} bordered
     * @private
     */
    _showError(msg, bordered) {
        bordered = bordered || false;

        if (!this.htmlInput.parentElement.querySelector('#date_of_birth-error')) {
            //
            let error = document.createElement('label');
            //
            error.innerText = msg || 'Formát data není správný';
            error.setAttribute('id', 'date_of_birth-error');
            error.setAttribute('for', 'date_of_birth');
            error.classList.add('invalid');

            if(bordered) {
                this.htmlInput.parentElement.classList.add('has-error');
            }

            this.htmlInput.parentElement.appendChild(error);
        }
    }

    _addClassNameListener(element, callback) {
        var elem = element;
        var lastClassName = elem.className;
        window.setInterval( function() {
            var className = elem.className;
            if (className !== lastClassName) {
                callback();
                lastClassName = className;
            }
        },10);
    }

    // -------------------------------- Test ----------------------------------------- \\

    /**
     * TODO: replace with some unit test framework
     * @private
     */
    _unitTestValidateDate() {
        if(this._isValidDate('20.90.1900')) {
            console.error('Date 1');
        }

        if(!this._isValidDate('01.01.2020')) {
            console.error('Date 2');
        }

        // Leap years
        if(this._isValidDate('29.02.2021')) {
            console.error('Leap 1');
        }

        if(!this._isValidDate('29.02.2020')) {
            console.error('Leap 2');
        }

        // Dates
        if(this._isValidDate('35.01.2020')) {
            console.error('Day 1');
        }


    }

}